import { compcheckApi } from "configs/api";
import { AppContext } from "context/appContext";
import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAllIndustries } from "slices/industrySlice";
import { RootState } from "configs/store";

interface Industry {
  _id: string;
  name: string;
  [key: string]: any;
}

export default function useIndustry() {
  const industryBaseRouter = "api/category";
  const { industries } = useSelector((state: RootState) => state.industries);
  const dispatch = useDispatch();
  const { showAlert } = useContext(AppContext);

  const getAllIndustries = async (): Promise<void> => {
    try {
      const response = await compcheckApi.get(industryBaseRouter);
      // Handle both response formats: { status: true, data: [...] } or { data: [...] } or direct array
      let industriesData = [];
      if (response.data?.status && response.data?.data) {
        industriesData = Array.isArray(response.data.data) ? response.data.data : [];
      } else if (response.data?.data) {
        industriesData = Array.isArray(response.data.data) ? response.data.data : [];
      } else if (Array.isArray(response.data)) {
        industriesData = response.data;
      }
      dispatch(setAllIndustries(industriesData));
    } catch (err: any) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err.message || 'Server error';
      console.error('Error fetching industries:', message);
      // Only show alert if it's a real error (not just empty response)
      if (err.response?.status !== 404) {
        showAlert('Failed to load categories. Please try again later.', 'error', 'Error');
      }
      // Set empty array on error to prevent infinite retries
      dispatch(setAllIndustries([]));
    }
  };

  return {
    getAllIndustries,
    industryBaseRouter,
    industries: industries as Industry[],
  };
}
